import { Component, ElementRef, Input, ViewChildren, QueryList } from '@angular/core';

import { ClienteECommerce } from './cliente-ecommerce';

import { BaseFormList, MessageService } from '../../../../../core';
import { tiposEcommerces } from './cliente-ecommerce-tipo';

@Component({
    selector: 'sgt-cliente-ecommerce',
    templateUrl: './cliente-ecommerce.component.html',
    styleUrls: ['./cliente-ecommerce.component.less']
})
export class ClienteECommerceComponent implements BaseFormList<ClienteECommerce> {
    /** Se pode editar os dados do form */
    @Input() canEdit = true;
    @Input() entities: ClienteECommerce[];
    tipos = tiposEcommerces;

    @ViewChildren('tipoSelect') tipoSelects: QueryList<ElementRef>;

    constructor(private messageService: MessageService) { }

    insert() {
        const entity = new ClienteECommerce();
        this.entities.push(entity);

        setTimeout(() => this.setFocusInsertTipo(), 200);
    }

    /** Seta o foco no select do tipo ao inserir um novo e-commerce */
    private setFocusInsertTipo() {
        if (!this.tipoSelects) {
            return;
        }
        // Obtendo o último select do tipo para setar o foco
        const tipoSelect = this.tipoSelects.last;
        if (tipoSelect) {
            jQuery(tipoSelect.nativeElement).focus();
        }
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir esse E-Commerce?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os dados dos e-commerce estão válidos */
    isValid(): boolean {
        if (!this.entities)  {
            return true;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            // Tipo
            if (!entity.tipo) {
                this.messageService.info('É necessário selecionar o tipo do e-commerce ou então excluí-lo', 'Informação');
                return false;
            }
            // URL
            if (!entity.url || entity.url.trim().length === 0) {
                this.messageService.info('É necessário selecionar o link do e-commerce ou então excluí-lo', 'Informação');
                return false;
            }
        }

        return true;
    }

    /** Resolve os e-commerces presentes no cliente */
    resolve() { }
    // resolve() {
    //     if (!this.entities) {
    //         return;
    //     }

    //     // Removendo os itens do array que não possuirem a URL do e-commerce informada
    //     for (let i = this.entities.length; i--; ) {
    //         const entity = this.entities[i];
    //         if (!entity.url || entity.url.trim().length === 0) {
    //             this.entities.splice(i, 1);
    //         }
    //     }
    // }

}
